var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('u-block',[_c('track-table-list',{attrs:{"list":_vm.tracks,"paginated":true}}),(_vm.total)?_c('u-pagination',{attrs:{"total":_vm.total,"start":_vm.start,"limit":_vm.limit},on:{"change-start":_vm.changeStart}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }